type TestTiming = {
  startDate: Date | string;
  finishDate?: Date | string | null;
  actualStartDate?: Date | string | null;
};

const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;

function toValidDate(value: Date | string | null | undefined): Date | null {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
}

function stimuliStartInsideTestWindow(test: TestTiming): Date | null {
  const stimuliStart = toValidDate(test.actualStartDate);
  const launch = toValidDate(test.startDate);
  const finish = toValidDate(test.finishDate);
  if (!stimuliStart || !launch) {
    return null;
  }
  const afterLaunch = stimuliStart.getTime() >= launch.getTime();
  const beforeFinish = !finish || stimuliStart.getTime() <= finish.getTime();
  return afterLaunch && beforeFinish ? stimuliStart : null;
}

export function resolveTestDurationStart(test: TestTiming): Date | string {
  return stimuliStartInsideTestWindow(test) ?? test.startDate;
}

export function getTestDuration(start: Date | string, end: Date | string): string {
  const elapsedSeconds = Math.floor(
    (new Date(end).getTime() - new Date(start).getTime()) / MILLISECONDS_PER_SECOND,
  );
  const minutes = Math.floor(elapsedSeconds / SECONDS_PER_MINUTE);
  const seconds = elapsedSeconds % SECONDS_PER_MINUTE;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function formatTestDuration(test: TestTiming): string {
  return getTestDuration(resolveTestDurationStart(test), test.finishDate);
}
